import { useChatModelSelection } from '../hooks/useChatModelSelection';
import { useConversationSearch } from '../hooks/useConversationSearch';
import { useChatPreferences } from '../hooks/useChatPreferences';
import { useChatMessages } from '../hooks/useChatMessages';
import { ChatComposer } from './chat/ChatComposer';
import { ChatMessageList } from './chat/ChatMessageList';

function ChatMessagesPane({ loadingHistory, messages, onPreferenceVote, votingModelKey, messagesEndRef, pendingProgress }) {
  return (
    <div className="flex-1 overflow-y-auto scroll-smooth p-4 md:p-8" data-testid="chat-messages">
      <ChatMessageList
        loadingHistory={loadingHistory}
        messages={messages}
        onPreferenceVote={onPreferenceVote}
        votingModelKey={votingModelKey}
        messagesEndRef={messagesEndRef}
        pendingProgress={pendingProgress}
      />
    </div>
  );
}

function ChatComposerPane(props) {
  return (
    <div className="bg-gradient-to-t from-background via-background to-transparent p-6">
      <ChatComposer {...props} />
    </div>
  );
}

function useChatInterfaceState(selectedKB, conversationId, onConversationCreated) {
  const modelSelection = useChatModelSelection();
  const conversationSearch = useConversationSearch(selectedKB);
  const preferences = useChatPreferences();
  const messages = useChatMessages({
    conversationId,
    onConversationCreated,
    selectedKB,
    selectedModels: modelSelection.selectedModels,
    setPreferenceStats: preferences.setPreferenceStats,
  });

  return {
    modelSelection,
    conversationSearch,
    preferences,
    messages,
  };
}

export default function ChatInterface({ selectedKB, conversationId, onConversationCreated }) {
  const { modelSelection, conversationSearch, preferences, messages } = useChatInterfaceState(
    selectedKB,
    conversationId,
    onConversationCreated
  );

  return (
    <div className="relative flex h-full flex-col bg-background">
      <ChatMessagesPane
        loadingHistory={messages.loadingHistory}
        messages={messages.messages}
        onPreferenceVote={preferences.handlePreferenceVote}
        votingModelKey={preferences.votingModelKey}
        messagesEndRef={messages.messagesEndRef}
        pendingProgress={messages.pendingProgress}
      />
      <ChatComposerPane
        modelOptions={modelSelection.modelOptions}
        selectedModels={modelSelection.selectedModels}
        onToggleModel={modelSelection.handleToggleModel}
        preferenceStats={preferences.preferenceStats}
        searchQuery={conversationSearch.searchQuery}
        onSearchConversations={conversationSearch.handleSearchConversations}
        showSearchResults={conversationSearch.showSearchResults}
        filteredConversations={conversationSearch.filteredConversations}
        onOpenConversation={conversationSearch.handleOpenConversation}
        input={messages.input}
        setInput={messages.setInput}
        selectedKB={selectedKB}
        loading={messages.loading}
        onSubmit={messages.handleSend}
      />
    </div>
  );
}
